export enum EnumTpEvento {
    Emissao = 0,
    Cancelamento = 1,
    Inutilizacao = 2,
    Denegado = 3,
    Entrada = 4,
    ResumoNFe = 5,
    ResumoEvento = 6,
    EventosDeAverbacao = 790700,
    EPEC = 110140,
    EventoDeCartaDeCorrecao = 110110,
    EventosDeConfirmacaoDeOperacao = 210200,
    EventosDeCienciaDaOperacao = 210210,
    EventosDeDesconhecimentoDaOperacao = 210220,
    EventosDeOperacaoNaoRealizada = 210240,
    EventosDeInternalizacaoSUFRAMA = 990910,
    EventosDeVistoriaSUFRAMA = 990900,
    EventosDeVistoriaSUFRAMASEFAZ = 630690,
    EventosDePedidoDeProrrogacaoDePrazo1 = 111500,
    EventosDePedidoDeProrrogacaoDePrazo2 = 111501,
    EventosDeCancelamentoDePedidoDeProrrogacaoDePrazo1 = 111502,
    EventosDeCancelamentoDePedidoDeProrrogacaoDePrazo2 = 111503,
    EventosDoFiscoEmRespostaAoPedidoDeProrrogacao1 = 411500,
    EventosDoFiscoEmRespostaAoPedidoDeProrrogacao2 = 411501,
    EventosDoFiscoEmRespostaDeCancelamentoAoPedidoDeProrrogacao1 = 411502,
    EventosDoFiscoEmRespostaDeCancelamentoAoPedidoDeProrrogacao2 = 411503
}